export default {
  en: {
    general: 'General',
    agent: 'Agent',
    rateCode: 'Rate Code',
    allotment: 'Allotment',
    promotion: 'Promotion',
    supplement: 'Supplement',
    transfer: 'Transfer',
    termsOfPayment: 'Terms of Payment'
  },
  th: {
    general: 'ทั่วไป',
    agent: 'ตัวแทน',
    rateCode: 'ประเภทเรท',
    allotment: 'Allotment',
    promotion: 'โปรโมชั่น',
    supplement: 'รายการเพิ่มเติม',
    transfer: 'รถรับส่ง',
    termsOfPayment: 'เงื่อนไขการชำระเงิน'
  }
}
